import React from 'react'
import Container from '@mui/material/Container'
import { authContext } from '../../../contexts/AuthContext'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Paper
} from '@mui/material'
import { Box } from '@mui/system'
import { withTranslation } from 'react-i18next'
import _ from 'lodash'
import CPDeleteIconButton from '../../Utils/CPDeleteIconButton'
import CPEditIconButton from '../../Utils/CPEditIconButton'
import DeleteDialog from '../../DeleteDialog'
import { AssignedClientsCard } from '../SociedadDetalle/AssignedClientsCard'
import { getSocietyById } from '../../../services/societies'
import SocietyCompliances from '../SociedadDetalle/SocietyCompliances'
import SocietyForm from '../Societies/SocietyForm'
import { apiUrl } from '../../../config/api'

class AdministracionSociety extends React.Component {
  constructor() {
    super()
    this.state = {
      society: {},
      editSociety: {},
      deleteSociety: {}
    }
  }

  static contextType = authContext

  componentDidMount() {
    const { location } = this.props
    const id = location.state.society.id

    this.loadSociety(id)
  }

  loadSociety = async (id) => {
    try {
      const society = await getSocietyById(id)
      if (society.constitution_date) {
        society.constitution_date = new Date(society.constitution_date)
          .toISOString()
          .substring(0, 10)
      }
      this.setState({ society })
    } catch (err) {
      console.error('Error fetching society:', err)
    }
  }

  handleEditSocietyOpen = (society) => {
    this.setState({ editSociety: society })
  }

  handleDeleteSocietyOpen = (society) => {
    this.setState({ deleteSociety: society })
  }

  handleDialogClose = () => {
    this.setState({ editSociety: {}, deleteSociety: {} })
  }

  updateSociety = async () => {
    const society = {
      ...this.state.editSociety,
      updated_by: this.context.auth.user.id,
      brandLabel: window.$brand
    }

    try {
      let url = apiUrl('UpdateSociety')
      await fetch(url, {
        method: 'POST',
        body: JSON.stringify(society)
      })

      console.log('Society updated')
      await this.loadSociety(society.id)
    } catch (err) {
      console.error('Error updating society:', err)
    }
    this.handleDialogClose()
  }

  deleteSociety = (society) => {
    society.updated_by = this.context.auth.user.id
    let url = apiUrl('DeleteSociety')
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(society)
    })
      .then((res) => console.log(res))
      .then(() => console.log('Society deleted'))
      .then(() => this.props.history.push('/societies'))
      .catch((err) => console.error(err))

    this.handleDialogClose()
  }

  render() {
    const { t } = this.props
    const { society } = this.state

    return (
      <Container maxWidth='lg' sx={{ mt: 4, mb: 4 }}>
        <Container component={Paper} sx={{ p: 2, mb: 2 }}>
          {society && (
            <>
              <Typography variant='subtitle2' sx={{ pt: 1, pb: 1 }}>
                {t('You_are_editing')}
              </Typography>
              <Typography component='h4' variant='h4' style={{ color: '#000' }}>
                <strong>{society.legal_id}</strong>
              </Typography>
              <Typography component='h6' variant='h6' style={{ color: '#000' }}>
                {society.type}
              </Typography>
            </>
          )}
        </Container>

        <Box sx={{ mt: 2 }}>
          <CPEditIconButton
            onClick={() => this.handleEditSocietyOpen(society)}
          />
          <CPDeleteIconButton
            onClick={() => this.handleDeleteSocietyOpen(society)}
          />
          <Button
            sx={{
              m: 3,
              backgroundColor: window.$brand === 'PRB' ? '#17afb6' : '#102a46',
              borderRadius: window.$brand === 'PRB' ? 0 : 5
            }}
            variant='contained'
            onClick={() => {
              this.props.history.push({
                pathname: `/society/${society.id}`,
              })
            }}
          >
            {t('go_to_society')}
          </Button>
        </Box>

        <Box sx={{ mt: 4 }}>
          {society && society.id && (
            <>
              <AssignedClientsCard
                societyId={society.id}
                societyLegalId={society.legal_id}
                adminMode={true}
              />
              <SocietyCompliances society={society} adminMode={true} />
            </>
          )}
        </Box>

        <Dialog
          open={!_.isEmpty(this.state.editSociety)}
          onClose={this.handleDialogClose}
        >
          <DialogTitle>
            {t('Update')} {t('Society')}
          </DialogTitle>
          <DialogContent
            sx={{
              display: 'flex',
              gap: 2,
              flexDirection: 'column',
              minWidth: 400
            }}
          >
            <SocietyForm
              value={this.state.editSociety}
              onChange={(v) => this.setState({ editSociety: v })}
              t={t}
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleDialogClose}>{t('Cancel')}</Button>
            <Button onClick={() => this.updateSociety(this.state.editSociety)}>
              {t('Save')}
            </Button>
          </DialogActions>
        </Dialog>

        <DeleteDialog
          item={this.state.deleteSociety}
          title={t('delete_society')}
          caption={t('delete_society_full_caption')}
          targetFunc={this.deleteSociety}
          handleDialogClose={this.handleDialogClose}
        />
      </Container>
    )
  }
}

export default withTranslation()(AdministracionSociety)
